import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BrandingField } from "./BrandingField";

export function IdentityTab() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Business identity</CardTitle>
        <CardDescription>
          Used in the site header, footer, email signatures, and wherever we
          display the business name.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-5 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <BrandingField
            brandingKey="identity.name"
            label="Business name"
            placeholder="Tristano's Catering"
          />
        </div>
        <div className="sm:col-span-2">
          <BrandingField
            brandingKey="identity.tagline"
            label="Tagline"
            placeholder="Fresh. Local. Unforgettable."
          />
        </div>
        <BrandingField
          brandingKey="identity.email"
          label="Contact email"
          type="email"
          placeholder="hello@tristanoscatering.ca"
        />
        <BrandingField
          brandingKey="identity.phone"
          label="Phone"
          type="tel"
          placeholder="(555) 555-0100"
        />
        <div className="sm:col-span-2">
          <BrandingField
            brandingKey="identity.address"
            label="Address"
            multiline
            placeholder="123 Main St, City, Province"
          />
        </div>
        <div className="sm:col-span-2">
          <BrandingField
            brandingKey="identity.hours"
            label="Business hours"
            multiline
            placeholder="Mon–Fri: 9am–5pm&#10;Sat: 10am–2pm"
          />
        </div>
      </CardContent>
    </Card>
  );
}
